import React, { useEffect, useState } from "react";
import Header from "./Header.js";
import Tarjeta from "./Tarjeta.js";

export default (props) => {
  const [vehiculo, setVehiculo] = useState([]);

  useEffect(() => {
    var url =
      "https://store.lenken.com.ar/lenkenapi/autos/compartir/" + props.interno;

    fetch(url)
      .then((data) => {
        return data.json();
      })
      .then((auto) => {
        setVehiculo(auto[0]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nombreModelorow = {
    background: "silver",
    height: "100px",
    fontFamily: "Audi Extended",
    fontSize: "70px",
    paddingLeft: "20px",
  };

  return (
    <div>
      <Header modelos={props.modelos} />
      <div className="row valign-wrapper" style={nombreModelorow}>
        {vehiculo.modelo}
      </div>
      <div className="row container">
        <Tarjeta
          key={vehiculo.id}
          auto={vehiculo}
          onSeleccionVehiculo={props.onSeleccionVehiculo}
          /* descuentos={props.descuentos} */
        />
      </div>
    </div>
  );
};
